import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { templateQuestionApi, selectAllQuestionsOrderedByWeight } from '../../reducers/templateQuestionSlice';

import { SortableList, SortableItem } from '@thaddeusjiang/react-sortable-list';
// import '@thaddeusjiang/react-sortable-list/dist/index.css';
import { Col, Row, Button } from "reactstrap";
import QuestionListItem from "./QuestionListItem";
import NewQuestionPopup from "./NewQuestionPopup";

const DragHandler = (props) => (
    <div
      {...props}
      style={{width: '20px', height: '20px', position: 'relative', float: 'left', top: '20px', left: '15px', cursor: 'pointer'}}
      className=""
    >
      <div className="" title="drag handler">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3 7.5L7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5"
          />
        </svg>
      </div>
    </div>
  );

const Template = ({ template }) => {
    const [items, setItems] = useState([]);
    const [maxWeight, setMaxWeight] = useState(0);
    const [showResponsePopup, setShowResponsePopup] = useState(false);
    const questions = useSelector((state) => selectAllQuestionsOrderedByWeight(state))
    const dispatch = useDispatch()

    useEffect(() => {
        if(template) {
            dispatch(templateQuestionApi.fetchAll({
                templateId: template.id,
                sorting: {
                    weight: 'ASC'
                }
            }))
        }
    }, [template, dispatch])

    useEffect(() => {
        let w = 0;
        questions.forEach((question) => {
            w = Math.max(w, question.weight)       
        }) 
        setMaxWeight(w)

        setItems(questions)
    }, [questions])

    useEffect(() => {
        if(template) {
            let w = 0
            let newItems = []
            items.forEach((item) => {
                w += 10
                if(w !== item.weight) {
                    newItems.push({...item, weight: w})
                }
            })

            if(newItems.length > 0) {
                dispatch(templateQuestionApi.updates({
                    templateId: template.id,
                    questions: newItems
                }))
            }
        }

    }, [dispatch, template, items])

    

    return (<div>
        <Row className="p-2">
            <Col md="10" className="text-left">
            <h1 style={{fontSize: '2.25rem', marginBottom: '1em'}}>{template ? template.name : null}</h1>
            </Col>
            <Col md="2">
                <div className="float-end">
                    <Button id="new_pos_btn" color="primary" style={{whiteSpace: "nowrap"}} onClick={() => { setShowResponsePopup(true) }} >
                        <span className="fas fa-plus"></span>
                    </Button>
                </div>
            </Col>
        </Row>
        
        <Row style={{padding: "1em", borderBottom: "2px solid #f3f1f1", borderTop: "1px solid #f3f1f1", fontWeight: "bold"}}>
            <Col md="11">Domanda</Col>
            <Col md="1"></Col>
        </Row>
        {
            questions.length > 0 
            ? <>
                <SortableList items={items} setItems={setItems}>
                {
                ({ items }) => (
                    (items.map((item) => (
                        <SortableItem
                            key={item.id}
                            id={item.id}
                            DragHandler={DragHandler}
                        >
                            <QuestionListItem template={template} question={item} />
                        </SortableItem>
                    )))
                )}
                </SortableList>
            </>
            : <Row style={{padding: "1em", borderBottom: "1px solid #f3f1f1", alignItems: 'center'}} >
                <Col md="12"><i>Inerisci la prima domanda nel questionario ...</i></Col>
            </Row>
        }
        { 
            showResponsePopup
                ? <NewQuestionPopup maxWeight={maxWeight} template={template} onToggle={() => { setShowResponsePopup(false) }} />
                : null
        }
    </div>)
}

export default Template;